import React, { useState } from 'react'
import { OpenInFull, Search, ShoppingCart } from '@mui/icons-material'
import { Link } from 'react-router-dom'

const ProductCard = ({ product, setCartItems, buttonAction }) =>{
    return(
        <div className='scale flex flex-col space-y-4 p-2 shadow-lg cursor-pointer'>
            <img className='rounded-lg' src={product.img} alt='shoe' />
            <p className='font-bold'>{product.name}</p>
            <p className='text-green-600 font-bold text-sm'>${product.price}</p>
            <div className='flex  space-x-2'>
            <button onClick={() => buttonAction('add', product.id, 1, product ) } className='bg-purple-700 font-semibold text-white p-2 rounded-lg'>Add to cart <ShoppingCart/></button>
            <Link to={`products/${product.id}`}>
                <button onClick={() => buttonAction('add', product.id, 1, product ) } className='bg-purple-200 font-semibold text-purple-900 p-2 rounded-lg'>View <OpenInFull/></button>
            </Link>
            </div>
        </div>
    )
}

const Products = ({ setProducts, setCartItems, buttonAction, products }) => {

    

  return (
    <div className='bg-white p-5 flex flex-col justify-center items-center'>
        {/* <div className='overlay'>
                <ProductView/>
        </div> */}
        <div className='productWrapper grid grid-cols-1 md:grid-cols-3 gap-5 p-6'>
            {products.map((product, index) => (
                
                    <ProductCard
                    key={index} 
                    buttonAction={buttonAction} 
                    setCartItems={setCartItems} 
                    product={product}/>
            ))}
        </div>
    </div>
  )
}

export default Products